import { render, staticRenderFns } from "./ToSPage.vue?vue&type=template&id=b7cab110&scoped=true"
var script = {}
import style0 from "./ToSPage.vue?vue&type=style&index=0&id=b7cab110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7cab110",
  null
  
)

export default component.exports